<ng-container *ngIf="orders.length > 0 && !!orders">
  <h3>Verwendet in folgenden Bestellungen (Orders):</h3>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'project_id'">Ordernummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_subject'">Name</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_status'">Orderdatum</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_delivery'" [clrDgSortOrder]="descSort">Lieferung</clr-dg-column>
    <clr-dg-placeholder>Keine dazugehörige Order gefunden!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let order of orders" [routerLink]="['/order/details', order.project_id, order.order_id]">
      <clr-dg-cell>{{ order.project_id }}.0002.{{ order.order_id }}</clr-dg-cell>
      <clr-dg-cell>{{ order.company_name }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_subject }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_status }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_delivery | date: 'dd.MM.yyyy' }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Orders pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{orders.length}} Order(s)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</ng-container>
